import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { itemStatusValues } from '@/lib/api/orpc/contracts/item-ledger';
export const ItemTableFilterSchema = z.object({
  ...dataGridSearchFields,
  freeText: z.string().optional(),
  // BE 既定（非 ARCHIVED / 非 OBSOLETE 等の振る舞いは BE 任せ）に合わせるため、
  // statusIn 未指定（undefined）はフィルタ未指定として扱う。Phase 1 はタブが無いため
  // URL から明示的に渡されたときのみ statuses を送る。
  statusIn: z.array(z.enum(itemStatusValues)).optional(),
  // 品目タイプによる絞り込み。BE は itemTypeIds パラメータを受け付け、未指定なら全タイプ。
  // 5 種の system-wide マスタ (ROH / HALB / FERT / HAWA / FOOD) を URL の配列で表現する。
  itemTypeIds: z.array(z.string()).optional()
});
export type ItemTableFilterSchema = z.infer<typeof ItemTableFilterSchema>;